<template>
  <!-- <v-content> -->
    <div>
      <transition name="fade">
    <router-view />
      </transition>

    <!-- <dashboard-core-footer /> -->
    </div>
  <!-- </v-content> -->
</template>

<script>
  export default {
    name: 'DashboardCoreView',

    components: {
      // DashboardCoreFooter: () => import('./Footer'),
    },
  }
</script>
